import Link from "next/link";

export default function ComparisonHero({
  title,
  subtitle,
  leftBrand,
  rightBrand,
  note = "14-day free trial · No credit card required",
}) {
  return (
    <section className="relative overflow-hidden bg-blue-primary-900 text-white pt-[140px] pb-[100px] px-6 lg:px-10 text-center">
      {/* Radial glow top-right */}
      <div className="absolute -top-[300px] -right-[200px] w-[900px] h-[900px] rounded-full bg-[radial-gradient(circle,rgba(0,116,230,0.12)_0%,transparent_70%)]" />
      {/* Radial glow bottom-left */}
      <div className="absolute -bottom-[200px] -left-[150px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(244,63,94,0.08)_0%,transparent_70%)]" />

      <div className="relative z-10 max-w-[800px] mx-auto">
        {/* VS Logos */}
        <div className="flex items-center justify-center gap-4 sm:gap-8 mb-12 flex-wrap">
          <div className="flex flex-col items-center gap-2">
            <div
              className={`border rounded-2xl py-5 px-6 sm:px-8 min-w-[140px] sm:min-w-[180px] font-extrabold text-lg sm:text-xl tracking-[1.5px] ${leftBrand.className || "border-blue-primary-500/30 bg-blue-primary-500/[0.08]"}`}
            >
              {leftBrand.label}
            </div>
          </div>
          <div className="bg-white/10 border border-white/15 rounded-full w-12 h-12 flex items-center justify-center font-extrabold text-sm text-white/60 flex-shrink-0">
            VS
          </div>
          <div className="flex flex-col items-center gap-2">
            <div
              className={`border rounded-2xl py-5 px-6 sm:px-8 min-w-[140px] sm:min-w-[180px] font-extrabold text-lg sm:text-xl tracking-[1.5px] ${rightBrand.className || "border-gray-cool-400/30 bg-gray-cool-400/[0.06] text-gray-cool-400"}`}
            >
              {rightBrand.label}
            </div>
          </div>
        </div>

        {/* Title */}
        <h1 className="font-inter text-[32px] sm:text-[42px] lg:text-[52px] font-black tracking-[-2px] leading-[1.1] mb-4">
          {title}
        </h1>

        {/* Subtitle */}
        <h2 className="font-inter text-base sm:text-lg lg:text-xl font-normal text-white/65 leading-relaxed mb-10">
          {subtitle}
        </h2>

        {/* CTA Buttons */}
        <div className="flex justify-center gap-4 flex-wrap">
          <Link
            href="/contact"
            className="inline-flex items-center gap-2 bg-blue-primary-500 hover:bg-[#005bb5] text-white px-9 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,116,230,0.35)]"
          >
            Free Consultation
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
          <Link
            href="/contact"
            className="inline-flex items-center bg-transparent text-white px-9 py-4 rounded-full text-base font-medium border-[1.5px] border-white/50 transition-all duration-300 hover:border-white hover:bg-white/5"
          >
            Get Started
          </Link>
        </div>

        {/* Note */}
        <p className="text-[13px] text-white/40 mt-5">{note}</p>
      </div>
    </section>
  );
}
